export default {"src":"/_next/static/media/placeholder.26418e8b.svg","height":640,"width":754,"blurWidth":0,"blurHeight":0};